"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable global-require */
const base = {
    qa: require("./qa/base"),
    staging: require("./staging/base"),
    production: require("./production/base")
};
exports.default = base;



// WEBPACK FOOTER //
// ./node_modules/@tvg/conf/cjs/content/base.js